export interface SignupInvitePrefill {
  inviteCode: string;
  email: string;
  hasInviteCode: boolean;
  hasEmail: boolean;
}

export function parseSignupInvitePrefill(search: string): SignupInvitePrefill {
  const params = new URLSearchParams(search);
  const inviteCode = params.get("inviteCode")?.trim() || "";
  const email = params.get("email")?.trim().toLowerCase() || "";

  return {
    inviteCode,
    email,
    hasInviteCode: inviteCode.length > 0,
    hasEmail: email.length > 0,
  };
}
